import type {ReactElement} from 'react';
import React from 'react';
import {isCustomPosterType} from '@Components/poster-editor/library/poster-editor-library';
import {PosterTemplatePanel} from '@Components/poster-template-panel/poster-template-panel';
import {useAppSelector} from '@/hooks';
import {onClickTemplateItem} from '@Libraries/editor-templates-library';

interface TemplatesPopupContentProps {
  isOpenedInMobileModal?: boolean;
  onAddTemplateCompleted?(): void;
  isContentVisibleToUser?: boolean;
}

export function TemplatesPopupContent({isOpenedInMobileModal = false, isContentVisibleToUser = true, ...props}: TemplatesPopupContentProps): ReactElement<any> {
  const posterType = useAppSelector((state) => {
    return state.posterEditor.posterObject?.type;
  });
  const customPosterWidth = useAppSelector((state) => {
    return state.posterEditor.posterObject?.userWidth;
  });
  const customPosterHeight = useAppSelector((state) => {
    return state.posterEditor.posterObject?.userHeight;
  });
  const posterWidth = useAppSelector((state) => {
    return state.posterEditor.posterObject?.width;
  });
  const posterHeight = useAppSelector((state) => {
    return state.posterEditor.posterObject?.height;
  });

  if (!posterWidth || !posterHeight) {
    throw new Error('whiteboard does not exist in templates popup');
  }

  const getPosterHeight = (): number => {
    if (isCustomPosterType() && customPosterHeight) {
      return customPosterHeight;
    }

    return posterHeight;
  };
  const getPosterWidth = (): number => {
    if (isCustomPosterType() && customPosterWidth) {
      return customPosterWidth;
    }
    return posterWidth;
  };

  const onAddTemplate = async (id: string): Promise<void> => {
    await onClickTemplateItem(id);
    if (props.onAddTemplateCompleted) {
      props.onAddTemplateCompleted();
    }
  };

  return (
    <PosterTemplatePanel
      onAddTemplate={onAddTemplate}
      posterTypeName={posterType?.name}
      sendHeightWidthParamsForPosterType={isCustomPosterType()}
      posterHeight={getPosterHeight()}
      posterWidth={getPosterWidth()}
      isOpenedInMobileModal={isOpenedInMobileModal}
      idGalleryTemplate={window.posterEditor?.whiteboard?.idGalleryTemplate}
      isContentVisibleToUser={isContentVisibleToUser}
    />
  );
}
